/** @jsxImportSource @emotion/react */
import { useMerchantApplicationContext } from 'contexts';
import PostApplicationSubmissionModule from 'modules/activation/post-application-submission';
import { FC } from 'react';
import { MerchantApplicationStatus } from 'types/responses/activation';
import { getGreeting } from 'utils';
import * as styles from './ActivationDashboard.styles';
import { FaqCard } from './FaqCard';
import { FinaliseAccountCard } from './FinaliseAccountCard';
import type { ActivationDashboardProps } from './types';

export const ActivationDashboardModule: FC<ActivationDashboardProps> = ({
  firstName = '',
  completedCount,
  totalCount,
  steps,
  applicationStatus,
  salesforceSdocContractUrl,
}) => {
  const { isPostSubmission } = useMerchantApplicationContext();
  const postSubmission = isPostSubmission();

  const firstNameDisplay = firstName ?? '';

  return (
    <div css={styles.activationDashboardRoot}>
      <div css={styles.activationDashboardContent}>
        {!postSubmission && (
          <>
            <h1 className="title3" css={styles.welcomeHeading}>
              Welcome {firstNameDisplay}
            </h1>

            <FinaliseAccountCard
              completedCount={completedCount}
              totalCount={totalCount}
              steps={steps}
            />
          </>
        )}

        {postSubmission && (
          <>
            {applicationStatus !== MerchantApplicationStatus.Declined && (
              <h1 className="title4" css={styles.welcomeHeading}>
                {`${getGreeting()} ${firstNameDisplay}`}
              </h1>
            )}

            <PostApplicationSubmissionModule
              status={applicationStatus}
              salesforceSdocContractUrl={salesforceSdocContractUrl}
            />
          </>
        )}

        <FaqCard applicationStatus={applicationStatus} />
      </div>
    </div>
  );
};

export default ActivationDashboardModule;
